import { BaseResultRow } from "./BaseResultRow";

export const SearchFilterResultRow = ({
  icon,
  subtitle,
}: {
  icon: React.ReactNode;
  subtitle: string;
}) => {
  return <BaseResultRow icon={icon} title={subtitle} />;
};
